import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Grid, styled, Tab, Tabs, } from '@mui/material';
import ItemList from '../ItemList';
const TabContainer = styled(Grid) `
  width: 100%;
  padding-top: 24px;
  justify-content: center;
`;
const TabbedItemList = ({ itemGroups, initialTab, filterText, canAutoSelect = false, onTabChange, isLoading = false, }) => {
    const [selectedTab, setSelectedTab] = React.useState(initialTab ?? Object.keys(itemGroups)[0]);
    const handleTabChange = (_, newValue) => {
        setSelectedTab(newValue);
        onTabChange?.(newValue);
    };
    return (_jsxs(Grid, { container: true, width: '100%', height: '100%', direction: 'column', children: [_jsx(Grid, { item: true, container: true, flex: 0, children: _jsx(Tabs, { value: selectedTab, onChange: handleTabChange, variant: 'fullWidth', sx: { width: '100%' }, children: Object.entries(itemGroups).map(([key, { title }]) => (_jsx(Tab, { label: title, value: key }, key))) }) }), _jsx(Grid, { item: true, container: true, flex: 1, children: Object.entries(itemGroups).map(([key, { title: _, ...group }]) => {
                    return (_jsx(TabContainer, { item: true, container: true, sx: { display: selectedTab !== key ? 'none' : undefined, height: '100%' }, children: _jsx(ItemList, { items: group.items, additionalItems: group.additionalItems, filterText: filterText, canAutoSelect: canAutoSelect && group.canAutoSelect && selectedTab === key, onToggleAdditionalItems: group.onToggleAdditionalItems, showAdditionalItems: group.showAdditionalItems, emptyMessage: group.emptyMessage, isLoading: isLoading }) }, key));
                }) })] }));
};
export default TabbedItemList;
//# sourceMappingURL=index.js.map